import { NavLink } from 'react-router-dom';

import { ListItemButton } from '@mui/material';

import { COLORS } from '../../../Constant/COLORS';

import { TypoPoppins } from '../../../Components/Typo';

const SubNavLink = ({ children, to }) => (
  <ListItemButton
    component={NavLink}
    to={to}
    sx={{ borderRadius: 2 }}
    style={({ isActive }) =>
      isActive
        ? { backgroundColor: COLORS.tealSoft, color: COLORS.teal }
        : { color: COLORS.inkSoft }
    }
  >
    <TypoPoppins fontWeight={600} sx={{ pointerEvents: 'none', color: 'inherit' }}>
      {children}
    </TypoPoppins>
  </ListItemButton>
);

export default SubNavLink;
